import { createContext, useContext } from 'react';

export const ControlGestureContext = createContext(null);

export function useControlGesture() {
  return useContext(ControlGestureContext);
}
